import actionTypes from 'redux/actions/actionTypes'
import { getVideoObject } from 'helpers/flocabularyVideoHelper'
import slideModeTypes from 'helpers/enums/slideModeTypes'
import searchStatuses from 'helpers/enums/storeSearchStatuses'

const defaultSearchState = {
	search: {
		state: searchStatuses.INIT,
		totalVideosCount: 0,
	},
	currentVideosIds: [],
	query: '',
}

const defaultState = {
	...defaultSearchState,
	entityUID: '',
	category: 'reading-writing',
	selectedVideoId: '',
	videos: [],
	categories: [],
	mode: slideModeTypes.CREATION,
	cancelUrl: '',
}

function initialize(state, action) {
	return {
		...state,
		entityUID: action.flocabularyUID,
	}
}

function initializeSuccess(state, action) {
	if (action.videoData) {
		const newStateVideo = setCurrentVideo(state, action)
		return {
			...newStateVideo,
			mode: slideModeTypes.EDITION,
			cancelUrl: action.cancelUrl,
		}
	} else {
		return {
			...state,
			cancelUrl: action.cancelUrl,
		}
	}
}

function setCategories(state, action) {
	return {
		...state,
		...defaultSearchState,
		categories: action.payload.categories,
	}
}

function getResultsSuccess(state, action) {
	if (action.payload) {
		const incomingVideos = action.payload.videos
		return {
			...state,
			videos: updateVideos(state, incomingVideos),
			currentVideosIds:
				[...state.currentVideosIds, ...getVideosIds(incomingVideos)],
			search: {
				...state.search,
				state: searchStatuses.READY,
				totalVideosCount: action.payload.count,
			},
		}
	} else {
		return state
	}
}

function getVideosIds(videos) {
	return videos.map( video => video.contentId )
}

function updateVideo(videos, incomingVideo) {
	const videoIndex = videos.findIndex(video =>
		video.contentId === incomingVideo.contentId)
	if (videoIndex !== -1) {
		const videoData = videos[videoIndex]
		const updatedVideo = getVideoObject(incomingVideo, videoData)
		videos = [...videos.slice(0, videoIndex),
			updatedVideo, ...videos.slice(videoIndex + 1)]
	} else {
		videos = [...videos, incomingVideo]
	}
	return videos
}

function updateVideos(state, incomingVideos) {
	let videos = [...state.videos]
	incomingVideos.forEach(incomingVideo => {
		videos = updateVideo(videos, incomingVideo)
	})
	return videos
}

function editFlocabulary(state) {
	return {
		...state,
		...defaultSearchState,
		mode: slideModeTypes.CREATION,
		selectedVideoId: '',
	}
}

function changeCategory(state, action) {
	return {
		...state,
		...defaultSearchState,
		category: action.categorySelected,
	}
}

function setSelectedVideo(state, action) {
	return {
		...state,
		selectedVideoId: action.videoId,
	}
}

function unsetSelectedVideo(state) {
	return {
		...state,
		selectedVideoId: '',
	}
}

function setCurrentVideo(state, action) {
	const { videoData } = action
	const oldVideos = [...state.videos]
	return {
		...state,
		videos: updateVideo(oldVideos, videoData),
		selectedVideoId: videoData.contentId,
	}
}

function setQuery(state, action) {
	return {
		...state,
		...defaultSearchState,
		query: action.query,
		category: 'reading-writing',
		search: {
			...defaultSearchState.search,
			state: searchStatuses.LOADING,
		},
	}
}

const flocabularyReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.FLOCABULARY_INITIALIZE_SUCCESS: {
			return initializeSuccess(state, action)
		}
		case actionTypes.FLOCABULARY_CATEGORIES_FETCHED: {
			return setCategories(state, action)
		}
		case actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL:
		case actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL_STANDALONE: {
			return initialize(state, action)
		}
		case actionTypes.FLOCABULARY_GET_RESULTS_SUCCESS: {
			return getResultsSuccess(state, action)
		}
		case actionTypes.FLOCABULARY_EDIT_FLOCABULARY: {
			return editFlocabulary(state)
		}
		case actionTypes.FLOCABULARY_CATEGORY_FLOCABULARY_SELECTED: {
			return changeCategory(state, action)
		}
		case actionTypes.FLOCABULARY_VIDEO_PREVIEW_SELECTED: {
			return setSelectedVideo(state, action)
		}
		case actionTypes.FLOCABULARY_CANCEL_PREVIEW_FLOCABULARY: {
			return unsetSelectedVideo(state, action)
		}
		case actionTypes.FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED:
		case actionTypes.FLOCABULARY_VIDEO_FETCHED: {
			return setCurrentVideo(state, action)
		}
		case actionTypes.FLOCABULARY_APPLY_SEARCH_SELECTED: {
			return setQuery(state, action)
		}
		default: return state
	}
}
export default flocabularyReducer
